import axios, { secondAxios } from "../../../../../../../../api/axios";

// export const createTimesheet = async ({ timesheet, taskId }) => {
export const createTimesheet = async ({ timesheet, taskId, accessToken }) => {
  console.log("creating timesheet", timesheet, taskId);

  // send timesheet along with taskId(from URI / state)
  return await secondAxios.post(
    "/timesheet/create",
    { ...timesheet, taskId },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};

export const getAllTimesheets = async ({ taskId, accessToken }) => {
  const { data } = await secondAxios.get("/timesheet/all/" + taskId, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return data;
};
export const getOneTimesheet = async () => {};

export const updateTimesheet = async ({ timesheet, taskId, accessToken }) => {
  console.log("updating timesheet", timesheet, taskId);
  return await secondAxios.put(
    "/timesheet/update/",
    { ...timesheet, hours: Number(timesheet.hours) || 0 },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};

export const deleteTimesheet = async ({ timesheetId, accessToken }) => {
  console.log({ timesheetId, accessToken }, "to be deleted");
  return await secondAxios.delete(`/timesheet/${timesheetId}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};
